import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Degree } from '@ascschool/model/category/degree.model';
import { OrganizesService } from '@ascschool/services/category/organizes.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { INzMessageType } from '@ascschool/interface/setting';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DepartmentOfEducationAndTrainingService } from '@ascschool/services/organization/department-of-educatio-and-training.service';
import { DistrictDepartmentOfEducationAndTrainingService } from '@ascschool/services/organization/district-department-of-education-and-training.service';
import { SchoolService } from '@ascschool/services/organization/school.service';

@Component({
  selector: 'app-them-dvql-cap-quan-huyen',
  templateUrl: './them-dvql-cap-quan-huyen.component.html',
  styleUrls: ['./them-dvql-cap-quan-huyen.component.scss']
})
export class ThemDvqlCapQuanHuyenComponent implements OnInit {
  infoSoForm = new FormGroup({
    id: new FormControl(0),
    educationAndTrainingCode: new FormControl(''),
    educationAndTrainingName: new FormControl('', Validators.required),
    director: new FormControl(''),
    directorPhoneNumber: new FormControl(''),
    directorEmail: new FormControl(''),
    phoneNumber: new FormControl('', Validators.required),
    fax: new FormControl(''),
    email: new FormControl(''),
    website: new FormControl(''),
    provinceId: new FormControl(null, Validators.required),
    districtId: new FormControl(null, Validators.required),
    wardId: new FormControl(''),
    villageName: new FormControl(''),
    address: new FormControl('', Validators.required),
    isActive: new FormControl(true, Validators.required),
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    schoolSubordinateType: new FormControl([]),
  });
  @Input() dataTransmission: any;
  @ViewChildren("label") labelElement;
  currentUser: any;
  provinceControl = this.infoSoForm.controls.provinceId;
  districtControl = this.infoSoForm.controls.districtId;
  wardControl = this.infoSoForm.controls.wardId;
  subordinatetypeControl = this.infoSoForm.controls.schoolSubordinateType;
  organizesControl = new FormControl;
  isEditMode = false;
  degreeItem = new Degree();
  errorMsg: string;
  isDisabled = false;
  listSo: ({
    id: number;
    educationAndTrainingName: string;
    checked: boolean;
  })[] = [];
  listSubordinateTypeSelect: number[] = [];
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    public utilsService: UtilsService,
    private organizesService: OrganizesService,
    private districtService: DistrictService,
    private wardService: WardService,
    private provinceService: ProvinceService,
    private service: DistrictDepartmentOfEducationAndTrainingService,
    private schoolService : SchoolService,
    private soGDService: DepartmentOfEducationAndTrainingService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
  }

  ngOnInit() {
    if (this.currentUser.accountType === 1) {
      this.listSubordinateTypeSelect.push(this.currentUser.eadId);
    }
    this.loadProvince();
    this.loadSo();
  }
  GetById(id: number){
    this.service.getById(id).subscribe((res: any) => {

      this.degreeItem = res;
    });
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  UpdateClose() {
    if (this.currentUser.accountType == 1 || this.currentUser.accountType == 5 || this.currentUser.accountType == 6) {
    this.infoSoForm.controls['schoolSubordinateType'].setValue(this.listSubordinateTypeSelect);
      if (this.infoSoForm.valid) {
        this.service.addOrUpdate(this.bindOfData(this.infoSoForm)).subscribe(res => {
          if (res.statusCode == 0) {
            this.utilsService.showNotification(INzMessageType.Success, res.message,3000)
            this.close();
          } else {
            this.utilsService.showNotification(INzMessageType.Error, res.message, 3000);
          }
        });
      } else {
        this.utilsService.showNotifyInvalidControls(this.infoSoForm, this.labelElement);
      }
    } else {
      this.utilsService.showNotification(INzMessageType.Warning, 'Bạn không có quyền khởi tạo', 1000);
    }
  }

  Update() {
    if (this.currentUser.accountType == 1 || this.currentUser.accountType == 5 || this.currentUser.accountType == 6) {
    this.infoSoForm.controls['schoolSubordinateType'].setValue(this.listSubordinateTypeSelect);
      if (this.infoSoForm.valid) {
        this.service.addOrUpdate(this.bindOfData(this.infoSoForm)).subscribe(res => {
          this.utilsService.showNotification(INzMessageType.Success, res.message, 1000);
          // refesh form
          this.clearForm();
        });
      } else {
        this.utilsService.showNotifyInvalidControls(this.infoSoForm, this.labelElement);
      }
    } else {
      this.utilsService.showNotification(INzMessageType.Warning, 'Bạn không có quyền khởi tạo Sở', 1000);
    }
  }

  clearForm(){
    this.infoSoForm.reset();
    this.provinceControl.setValue(null);
    this.districtControl.setValue(null);
    this.wardControl.setValue(null);
    this.infoSoForm.controls.id.setValue(0);
    this.infoSoForm.controls.isActive.setValue(true);
  }
  getProvinceACFn: (value: any) => Observable<any>;
  getorganizesACFn: (value: any) => Observable<any>;
  getDistrictACFn: (value: any) => Observable<any>;
  getWardACFn: (value: any) => Observable<any>;
  getVillageACFn: (value: any) => Observable<any>;
  // getSubordinatetypeACFn: (value: any) => Observable<any>;

  loadOrganizes(reset = true) {
    this.getorganizesACFn = (value: any) => this.organizesService.getOrganizesSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.organizeName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (reset) this.organizesControl.setValue(null);
  }
  changeOrganizes(control: FormControl) {
    this.organizesControl = control;
  }


  loadProvince(reset = true) {
    this.getProvinceACFn = (value: any) => this.provinceService.getProvinceSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (reset) this.provinceControl.setValue(null);
  }

  changeProvince(control: FormControl) {
    this.provinceControl = control;
    this.loadDistrict();
    this.districtControl.setValue(null);
    this.wardControl.setValue(null);
  }

  loadDistrict(reset = true) {
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({ searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (reset) this.districtControl.setValue(null);
  }

  changeDistrict(control: FormControl) {
    this.districtControl = control;
    this.loadWard();
    this.wardControl.setValue(null);
  }

  loadWard(reset = true) {
    this.getWardACFn = (value: any) => this.wardService.getWardSelectPaging({ searchTerm: value, DistrictId: this.valueIfHas(this.districtControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (reset) this.wardControl.setValue(null);
  }

  changeWard(control: FormControl) {
    this.wardControl = control;
  }

  loadSo() {
    this.soGDService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listSo = res.results.map(x => ({ id: x.id, educationAndTrainingName: x.educationAndTrainingName, checked: false }));
    });
  }
  // loadSubordinatetype(reset = true) {
  //   this.getSubordinatetypeACFn = (value: any) => this.subordinatetypeService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
  //     map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.subordinateTypeName })) : [{ id: null, text: 'Không có dữ liệu' }])
  //   );
  //   if (reset) this.subordinatetypeControl.setValue(null);
  // }

  // changeSubordinatetype(control: FormControl) {
  //   this.subordinatetypeControl = control;
  // }

  valueIfHas(control) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }

  bindOfData(formGroup: FormGroup)  {
    let data ;
    data = formGroup.value;
    const controls = formGroup.controls;
    for (const name in controls) {
      if(data[name] && data[name].id){
        data[name] = data[name].id
      }
    }
    return data;
  }
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
}
